import { Locales } from '@monoimin/sb-types';
import { locales } from '@monoimin/constants';

import { getAlterLocales } from './getLocale';

type AlterCategories = string[];

export async function getCategoryAlternates({
  currentLocale,
  fetchAlterCategories,
  categoriesMapper,
}: {
  currentLocale?: Locales;
  fetchAlterCategories: (locale: Locales) => Promise<AlterCategories>;
  categoriesMapper: (story: {
    list?: AlterCategories;
    locale: Locales;
  }) => Locales | undefined | null | false;
}) {
  const alterLocales = currentLocale ? getAlterLocales(currentLocale) : locales;

  const alterStories = await Promise.all(
    alterLocales.map((l) =>
      fetchAlterCategories(l).then((categories) => ({
        list: categories,
        locale: l,
      }))
    )
  );

  return alterStories.map(categoriesMapper).filter(Boolean) as Locales[];
}
